"use strict";
/**
 * WHICH FIELD A LAB RESULT'S VALUE GOES IN — decided ONCE, for both sides.
 *
 * THE DEFECT THIS EXISTS TO END. The server mapped five parameter result types
 * onto the NUMERIC result kind and then refused any payload without
 * `numericValue`. The browser had its own, narrower idea: it sent
 * `numericValue` only when the type was literally `NUMERIC`, and `textValue`
 * for everything else. So every PERCENTAGE, RATIO, CALCULATED and TITER
 * parameter was sent as text and refused with "A numeric parameter requires
 * numericValue" — a differential count could not be entered at all, and the
 * message named a field the operator had no way to supply.
 *
 * Two implementations of one rule, in two languages, disagreeing. The fix is
 * not to correct the browser's copy — it is to delete the copy. Both sides
 * import this, the same way the charge-tier engine is shared, so the question
 * "is this parameter numeric?" has exactly one answer in the product.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NUMERIC_RESULT_TYPES = void 0;
exports.isNumericResultType = isNumericResultType;
exports.isRangeResultType = isRangeResultType;
exports.deriveResultKind = deriveResultKind;
/**
 * Parameter result types whose value is a NUMBER, whatever they are called.
 *
 * PERCENTAGE and RATIO are numeric: a neutrophil count of 62% is the number
 * 62, and its unit says the rest. CALCULATED is numeric because a formula
 * yields one. TITER is numeric because a dilution is compared and trended.
 * None of them is a different KIND of result; they are numbers with different
 * units and provenance.
 *
 * APPROX_NUMERIC is numeric too ("user will enter approximate value like
 * 0.5-1.2", desk 2026-09-18) — it just carries TWO numbers
 * (`numericValueLow`/`numericValueHigh`) instead of one `numericValue`. See
 * `isRangeResultType` for the payload-shape distinction that follows from
 * that; this function only answers "is the RESULT KIND numeric".
 */
exports.NUMERIC_RESULT_TYPES = [
    'NUMERIC',
    'APPROX_NUMERIC',
    'CALCULATED',
    'PERCENTAGE',
    'RATIO',
    'TITER',
];
/** True when a parameter of this type must carry `numericValue` (or, for APPROX_NUMERIC, a range). */
function isNumericResultType(resultType) {
    return exports.NUMERIC_RESULT_TYPES.includes(resultType);
}
/**
 * True for the ONE result type whose numeric value is a RANGE
 * (`numericValueLow`/`numericValueHigh`) rather than a single `numericValue`.
 * Kept as its own function rather than a second inline string comparison
 * scattered across the entry service and the entry form, so the two cannot
 * drift on which type this is.
 */
function isRangeResultType(resultType) {
    return resultType === 'APPROX_NUMERIC';
}
function deriveResultKind(resultType, hasIsolates) {
    if (isNumericResultType(resultType))
        return 'NUMERIC';
    if (resultType === 'NARRATIVE' || resultType === 'STRUCTURED_PATHOLOGY')
        return 'NARRATIVE';
    if (resultType === 'ORGANISM' || resultType === 'MIC' || resultType === 'SUSCEPTIBILITY')
        return 'MICROBIOLOGY';
    if (resultType === 'TEXT' || resultType === 'DOCUMENT' || resultType === 'IMAGE')
        return 'TEXT';
    // Everything else in the 21-value vocabulary is a coded verdict.
    if (hasIsolates)
        return 'MICROBIOLOGY';
    return 'CODED';
}
//# sourceMappingURL=lab-result-kind.js.map